import { useEffect } from "react";
function useHandleBackButton(callback) {
  useEffect(function () {
    // Handler for the 'popstate' event
    var handlePopState = function handlePopState(event) {
      callback();
    };

    // Add event listener for 'popstate'
    window.addEventListener('popstate', handlePopState);

    // Cleanup function to remove the event listener
    return function () {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [callback]); // Re-run the effect only if the callback changes
}
export default useHandleBackButton;